import React, { useState, useEffect, useContext } from "react";
import { Modal, Button, Table } from "flowbite-react";
import GlobalContext from "../connections/GlobalContext";
import axios from "axios";
import Head_data from "../components/Head_data";
import Select from "react-select";

import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { Calendar as CalendarIcon } from "lucide-react";
import Spare_take_by_admin from "./spare_take_by_admin";
import engineGif from "../image/engine.gif";

const Spare_log_admin = ({ theme }) => {
  const { globalValue } = useContext(GlobalContext);
  const [spareLogs, setSpareLogs] = useState([]);
  const [selectedLog, setSelectedLog] = useState(null);
  const [modalType, setModalType] = useState("");
  const [date, setDate] = useState("");
  const [temp_est, setTemp_est] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [open, setOpen] = useState(false);
  const [staff_id, setStaff_id] = useState("");
  const [staffs_, setStaffs_] = useState([]);

  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [filtered, setFiltered] = useState(spareLogs);


  useEffect(() => {
    const filteredData = spareLogs.filter((branch) =>
      branch['vehicle_no'].toLowerCase().includes(searchTerm.toLowerCase()) || branch['customer_name'].toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFiltered(filteredData);
  }, [searchTerm, spareLogs]);

  const fetchStaffs = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${globalValue}/staffs`, {
        params: {
          data: sessionStorage.getItem("branch"),
          position: "",
        },
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        },
      });
      console.log(response.data);

      const staffOptions = response.data
        .filter((staff) => staff[6][0] !== "superadmin")
        .map((staff) => ({
          value: staff[3],
          label: staff[2],
        }));

      setStaffs_(staffOptions);
    } catch (error) {
      console.error("Error fetching staff data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${globalValue}/spare_log_admin`, {
        params: {
          data: sessionStorage.getItem("branch"),
        },
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        },
      });

      setSpareLogs(response.data);
    } catch (error) {
      console.error(
        "Error fetching spare logs:",
        error.response?.data || error.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
    fetchStaffs();
  }, []);

  const openModal = (log, type) => {
    console.log(log);
    setSelectedLog(log);
    setModalType(type);
  };

  const closeModal = () => {
    setSelectedLog(null);
    setModalType("");
  };
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  const toggleCalendar = () => setShowCalendar(!showCalendar);

  return (
    <div>
      <div
        className={`md:ml-[250px] w-full md:w-[calc(100%-250px)] relative  mt-16 h-[92vh] flex justify-center items-center box-border`}
      >
        <div className="absolute right-6 bottom-8 z-50">
          <button
            onClick={() => setShowCalendar(!showCalendar)}
            className="flex items-center gap-2 bg-purple-500 p-2 text-white rounded-3xl hover:bg-blue-600 transition"
          >
            <CalendarIcon size={30} />
          </button>

          {loading && (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-200 bg-opacity-50 z-50">
              <img src={engineGif} alt="Loading..." className="w-24 h-24" />
            </div>
          )}

          {showCalendar && (
            <div className="absolute bottom-full right-0 mt-2 shadow-lg bg-white p-2 rounded-lg z-50 w-[250px] md:w-auto">
              <Calendar
                onChange={(date) => {
                  setSelectedDate(date);
                  setShowCalendar(false);
                  console.log("date" + date);
                }}
                value={selectedDate}
              />
            </div>
          )}
        </div>
        <div className="w-[95%] md:w-[98%] h-[95%]  bg-white px-4 py-2 rounded-xl shadow-xl overflow-auto">

          {!showTable ? (
            <>
              <div className="w-full flex justify-between text-gray-600 mb-6">
                <Head_data data="Spare Log" font="" size="3xl" />
              </div>
              <input
                type="text"
                placeholder="Search branch by name"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full md:w-1/3 px-4 my-2 py-2 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
              />

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {filtered
                  .filter((log) =>
                    selectedDate
                      ? new Date(log.date).toDateString() ===
                      new Date(selectedDate).toDateString()
                      : true
                  )
                  .map((log, index) =>
                    log.vehicle_no !== "Unknown" ? (
                      <div
                        key={index}
                        className="p-4 border rounded-lg shadow hover:shadow-lg cursor-pointer bg-gray-100 "
                      >
                        <h3 className="text-lg font-bold">{log.vehicle_no}</h3>
                        <p className="text-sm">Customer: {log.customer_name}</p>
                        <p className="text-sm">
                          Date: {new Date(log.date).toLocaleString()}
                        </p>
                        <div className="flex gap-2 mt-4">
                          <Button
                            size="xs"
                            onClick={() => openModal(log, "spares")}
                            className="bg-blue-500 hover:bg-blue-600 text-white"
                          >
                            Spares
                          </Button>
                          <Button
                            size="xs"
                            onClick={() => openModal(log, "staffs")}
                            className="bg-green-500 hover:bg-green-600 text-white"
                          >
                            Staffs
                          </Button>
                          {log.status !== "1" ? (
                            <Button
                              size="xs"
                              onClick={() => {
                                setTemp_est(log.estimate_id);
                                console.log(
                                  "est id is :",
                                  log.estimate_id,
                                  log.vehicle_no,
                                  new Date(log.date).toLocaleString()
                                );
                                setOpen(true);
                                setStaff_id("");
                              }}
                              className="bg-gray-500 hover:bg-gray-300 text-white"
                            >
                              Assign Spares
                            </Button>
                          ) : null}
                        </div>
                      </div>
                    ) : null
                  )}
              </div>
            </>
          ) : (
            <Spare_take_by_admin
              estimate_id={temp_est}
              setShowTable={setShowTable}
              refresh={fetchLogs}
            />
          )}

          <Modal show={open} onClose={() => setOpen(false)}>
            <Modal.Header className="flowbite-modal-h">
              Assign spares to staff
            </Modal.Header>
            <Modal.Body className="flowbite-modal-h h-auto">
              <Select
                options={staffs_}
                value={staffs_.find((s) => s.value === staff_id) || null}
                onChange={(selected) => setStaff_id(selected ? selected.value : "")}
                placeholder="Select Staff"
                isClearable
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 })
                }}
              />

            </Modal.Body>
            <Modal.Footer className="flowbite-modal-h">
              <Button
                disabled={!staff_id}
                onClick={() => {
                  setOpen(false);
                  sessionStorage.setItem("temp_user", staff_id);
                  setShowTable(true);
                }}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>

          {selectedLog && modalType && (
            <Modal show={true} size="2xl" onClose={closeModal}>
              <Modal.Header className="flowbite-modal-h">
                {modalType === "spares" ? "Spares Details" : "Staff Details"}
              </Modal.Header>
              <Modal.Body className="flowbite-modal-h">
                {modalType === "spares" ? (
                  Object.keys(selectedLog.spares_grouped_by_service || {})
                    .length > 0 ? (
                    Object.keys(selectedLog.spares_grouped_by_service).map(
                      (serviceName, idx) => (
                        <div key={idx} className="mb-4">
                          <h4 className="font-bold mb-2">
                            Service Name: {serviceName}

                          </h4>
                          <table className="w-full border border-gray-300 shadow-md rounded-lg overflow-hidden">
                            <thead className="bg-gray-200 text-gray-900 text-sm font-semibold uppercase">
                              <tr>
                                <th className="p-4 text-left border-b border-gray-300">
                                  Spare Name
                                </th>
                                <th className="p-4 text-left border-b border-gray-300">
                                  Price
                                </th>
                                <th className="p-4 text-left border-b border-gray-300">
                                  Quantity
                                </th>
                                <th className="p-4 text-left border-b border-gray-300">
                                  Taken
                                </th>
                                <th className="p-4 text-left border-b border-gray-300">
                                  Remaining
                                </th>
                              </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-300">
                              {selectedLog.spares_grouped_by_service[
                                serviceName
                              ].map((spare, spareIdx) => (
                                <tr
                                  key={spareIdx}
                                  className="hover:bg-gray-100 transition duration-200"
                                >
                                  <td className="p-4 border-r border-gray-300">
                                    {spare.spare_name}
                                  </td>
                                  <td className="p-4 border-r border-gray-300">
                                    {spare.price}
                                  </td>
                                  <td className="p-4 border-r border-gray-300">
                                    {spare.totalQuantity}
                                  </td>
                                  <td className="p-4 border-r border-gray-300">
                                    {spare.quantity}
                                  </td>
                                  <td className="p-4 font-bold text-red-500">
                                    {spare.totalQuantity - spare.quantity}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )
                    )
                  ) : (
                    <p className="text-gray-500 text-center py-4">
                      No spare details available.
                    </p>
                  )
                ) : (
                  <>
                    {Object.keys(selectedLog.staff_details_grouped || {})
                      .length > 0 ? (
                      Object.keys(selectedLog.staff_details_grouped).map(
                        (staffId, idx) => (
                          <div key={idx} className="mb-4">
                            <h4 className="font-bold mb-2">
                              Staff ID: {staffId}
                            </h4>
                            <table className="w-full border border-gray-300 shadow-md rounded-lg overflow-hidden">
                              <thead className="bg-gray-200 text-gray-900 text-sm font-semibold uppercase">
                                <tr>
                                  <th className="p-4 text-left border-b border-gray-300">
                                    Staff Name
                                  </th>
                                  <th className="p-4 text-left border-b border-gray-300">
                                    Description
                                  </th>
                                  <th className="p-4 text-left border-b border-gray-300">
                                    Date
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="bg-white divide-y divide-gray-300">
                                {selectedLog.staff_details_grouped[staffId].map(
                                  (staffDetail, detailIdx) => (
                                    <tr
                                      key={detailIdx}
                                      className="hover:bg-gray-100 transition duration-200"
                                    >
                                      <td className="p-4 border-r border-gray-300">
                                        {staffDetail.staff_name}
                                      </td>
                                      <td className="p-4 border-r border-gray-300">
                                        {staffDetail.description}
                                      </td>
                                      <td className="p-4 font-medium text-gray-700">
                                        {new Date(
                                          staffDetail.date
                                        ).toLocaleString("en-GB", {
                                          day: "2-digit",
                                          month: "short",
                                          year: "numeric",
                                          hour: "2-digit",
                                          minute: "2-digit",
                                        })}
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        )
                      )
                    ) : (
                      <p className="text-gray-500 text-center py-4">
                        No staff details available.
                      </p>
                    )}

                    {selectedLog.others && selectedLog.others.length > 0 && (
                      <div className="mb-4">
                        <h4 className="font-bold mb-2 text-red-600">
                          Other Spare Transactions
                        </h4>
                        <table className="w-full border border-gray-300 shadow-md rounded-lg overflow-hidden">
                          <thead className="bg-gray-200 text-gray-900 text-sm font-semibold uppercase">
                            <tr>
                              <th className="p-4 text-left border-b border-gray-300">
                                Staff Name
                              </th>
                              <th className="p-4 text-left border-b border-gray-300">
                                Description
                              </th>
                              <th className="p-4 text-left border-b border-gray-300">
                                Date
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-300">
                            {selectedLog.others.map((otherDetail, otherIdx) => (
                              <tr
                                key={otherIdx}
                                className="hover:bg-gray-100 transition duration-200"
                              >
                                <td className="p-4 border-r border-gray-300">
                                  {otherDetail[2]}
                                </td>
                                <td className="p-4 border-r border-gray-300">
                                  {otherDetail[3]}
                                </td>
                                <td className="p-4 font-medium text-gray-700">
                                  {new Date(otherDetail[4]).toLocaleString(
                                    "en-GB",
                                    {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    }
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </>
                )}
              </Modal.Body>
              <Modal.Footer className="flowbite-modal-h">
                <Button
                  size="sm"
                  onClick={closeModal}
                  className="bg-red-500 hover:bg-red-600 text-white"
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          )}
        </div>
      </div>
    </div>
  );
};

export default Spare_log_admin;
